<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="线上样品" name="list">
      <List ref="list" />
    </el-tab-pane>
    <el-tab-pane label="上传记录" name="history">
      <History ref="history" />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import List from './List.vue';
import History from './History.vue';

export default {
  name: 'sample-list',
  components: {
    List,
    History,
  },
  data() {
    return {
      activeName: 'history',
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 跳转到列表页
      if (to.params.status === 'submitSuccessToListTab1') {
        vm.activeName = 'list';
        vm.$refs.list.selectTab = 'Tab1';
        vm.reloadData();
      } else if (to.params.status === 'submitSuccessToHistoryTab1') {
        // 跳转到记录页
        vm.activeName = 'history';
        vm.$refs.history.selectTab = 'Tab1';
        vm.reloadData();
      } else if (to.params.status === 'submitSuccessToHistoryTab2') {
        // 跳转到记录页
        vm.activeName = 'history';
        vm.$refs.history.selectTab = 'Tab2';
        vm.reloadData();
      } else if (to.params.status === 'reloadData') {
        vm.reloadData();
      }
    });
  },
  watch: {
    activeName(val) {
      if (val === 'list' || val === 'history') {
        this.$refs[val].getList();
      }
    },
  },
  methods: {
    reloadData() {
      this.$nextTick(() => {
        this.$refs[this.activeName].onSearch();
      });
    },
  },
};
</script>
